import React, { useEffect, useState } from "react";
import "./styles.scss";

const FadeComponent = ({ show, onEndAction, content }) => {
  const [render, setRender] = useState(show);

  useEffect(() => {
    if (show) setRender(true);
  }, [show]);

  const onAnimationEnd = () => {
    setRender(false);
    onEndAction();
  };

  return (
    render && (
      <div
        className="fade-container"
        style={{
          animation: `${show ? "fadeIn" : "fadeOut"} 5s`,
          position: "absolute",
        }}
        onAnimationEnd={onAnimationEnd}
      >
        {content}
      </div>
    )
  );
};

export default FadeComponent;
